import {
   RecoveryCodesSummaryQuery,
   TimeBasedAuthenticationConfigurationRemoveCommand,
} from '@dreryk/egabinet-security-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { Button, dispatchSnackbarPositiveEvent, ShowModalEventInterceptor } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../translations';

type ExistingAssociationPanelRemoveAssociationButtonProps = {
   readonly onRemoveSuccess: VoidFunction;
};

export const ExistingAssociationPanelRemoveAssociationButton = (
   props: ExistingAssociationPanelRemoveAssociationButtonProps
): JSX.Element => {
   const { executeAsync: removeAssociation } = useCqrsCommand<void, undefined>(
      () => new TimeBasedAuthenticationConfigurationRemoveCommand(),
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(mfaSettingsTranslationKeys.associationRemovedSuccessfully);
            props.onRemoveSuccess();
            refetchCqrsQuery(RecoveryCodesSummaryQuery);
         },
      }
   );

   return (
      <ShowModalEventInterceptor
         testId={'removeAssociation'}
         shouldShowModal
         title={mfaSettingsTranslationKeys.youAreRemovingAssociation}
         content={mfaSettingsTranslationKeys.areYouSureRemovingAssociation}
         confirmationButtonLabel={mfaSettingsTranslationKeys.turnOff}
      >
         <Button
            testId={'removeAssociation'}
            label={mfaSettingsTranslationKeys.removeAssociation}
            onClick={async () => removeAssociation(undefined)}
         />
      </ShowModalEventInterceptor>
   );
};
